export const HOME_PAGE = '/';
export const ORDER_PAGE = '/order';
export const RESULT_PAGE = '/result';
export const NEWS = '/tin-tuc';


export const TIN_TUC_DETAIL = '/tin-tuc/:id';
export const VNPT_NET_ONLINE = '/vnpt-net-online';
export const VNPT_NET_ONLINE_DETAIL = '/vnpt-net-online/:id';

export const MEDIA = '/media'
export const THU_VIEN_VIDEO = '/thu-vien-video';
export const THU_VIEN_HINH_ANH = '/thu-vien-hinh-anh';

export const DOCS = '/van-ban';
export const HIEN_KE = '/hien-ke';
